<template>
  <div class="my-2">
    <router-link :to="`/movies/${data.id}`"
      ><button-base :background="'gray'"
        ><span class="mr-2"><i class="fas fa-long-arrow-alt-left"></i></span>Go
        back</button-base
      ></router-link
    >
  </div>
  <!-- CASTS -->
  <div class="mb-10">
    <h1 class="text-xl font-semibold uppercase">
      Casts
    </h1>

    <ul class="flex flex-wrap items-center justify-around">
      <li
        v-for="cast in data.credits.cast"
        :key="cast.id"
        class="text-center text-gray-500 m-1 s:w-32 w-24 shadow bg-secondary p-2"
      >
        <router-link
          :to="{
            path: '/celebs/',
            name: 'CelebDetails',
            params: {
              id: cast.id
            }
          }"
        >
          <div class="h-28 s:h-48 mb-2">
            <img
              v-if="cast['profile_path']"
              :src="profileImageUrl(cast['profile_path'])"
              :alt="cast['name']"
              class="rounded w-full h-full"
            />
            <img
              v-else
              src="@/assets/images/avatar-icon.png"
              :alt="cast['name']"
              class="rounded w-full h-full"
            />
          </div>
          <p>{{ cast["name"] }}</p>
          <p class="text-sm">
            ({{
              cast["known_for_department"] === "Acting"
                ? cast["gender"] === 1
                  ? "Actress"
                  : "Actor"
                : cast["known_for_department"]
            }})
          </p>
        </router-link>
      </li>
    </ul>
  </div>
  <!-- CREW -->
  <div class="my-10" v-if="data.credits && data.credits.crew.length">
    <h1 class="text-xl font-semibold uppercase">
      Crew
    </h1>

    <ul class="flex flex-wrap items-center justify-around">
      <li
        v-for="crew in data.credits.crew"
        :key="crew.id"
        class="text-center text-gray-500 m-1  s:w-32 w-24  shadow bg-secondary p-2"
      >
        <router-link
          :to="{
            path: '/celebs/',
            name: 'CelebDetails',
            params: {
              id: crew.id
            }
          }"
        >
          <div class="h-28 s:h-48 mb-2">
            <img
              v-if="crew['profile_path']"
              :src="profileImageUrl(crew['profile_path'])"
              :alt="crew['name']"
              class="rounded w-full h-full"
            />
            <img
              v-else
              src="@/assets/images/avatar-icon.png"
              :alt="crew['name']"
              class="rounded w-full h-full"
            />
          </div>
          <p>{{ crew["name"] }}</p>
          <p class="text-sm">({{ crew["job"] }})</p>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "casts",
  props: ["data"],
  mounted() {
    console.log(this.data);
  }
};
</script>

<style></style>
